module.exports = __webpack_public_path__ + "static/media/20_3.856ba2da.png";